import { IProductDelivery } from '../types/orders';

export const groupBySku = (products: IProductDelivery[]) => {
  if (!products) return [];
  const grouped: Record<string, IProductDelivery[]> = {};
  products?.forEach(product => {
    if (!grouped[product?.sku || '']) {
      grouped[product?.sku || ''] = [];
    }
    grouped[product?.sku || ''].push(product);
  });

  return Object.values(grouped);
};
